export default __webpack_public_path__ + "static/media/White_Tree.aea5fd0e.png";